import React, { Component } from "react";
import ExportFormRecurrent from "./Forms/Rec";
import Registry from "../../../Utils/Registry";
import { NotificationManager } from "react-notifications";


export default class ExportRectItem extends Component {
    static defaultProps = {
        item: {},
        onUpdate: () => {}
    };

    state = {
        showForm: false,
        loading: false
    }

    toggleForm = () => {
        this.setState({showForm: !this.state.showForm});
    };

    postUpdate = data => {
        const api = Registry.registered("api");
        const user = Registry.registered("user");
        const { item, onUpdate } = this.props;

        if(user && api){
            this.setState({loading: true});
            api.put(`/business/${user.business_id}/recurrent_export/${item.id}`, data)
                .then(_ => {
                    this.setState({loading: false, showForm: false});
                    NotificationManager.success("Export mis à jour");
                    onUpdate && onUpdate();
                    window.scrollTo(0, 0);
                })
                .catch(_ => {
                    NotificationManager.error("Impossible de mettre à jour l'export");
                    this.setState({loading: false});
                })
        }
        else
            console.error("No User or API Instance");
    };

    removeExport = () => {
        const api = Registry.registered("api");
        const user = Registry.registered("user");
        const { item, onUpdate } = this.props;

        if(user && api){
            this.setState({loading: true});
            api.del(`/business/${user.business_id}/recurrent_export/${item.id}`)
                .then(_ => {
                    this.setState({loading: false, showForm: false});
                    NotificationManager.success("Export supprimé");
                    onUpdate && onUpdate();
                    window.scrollTo(0, 0);
                })
                .catch(_ => {
                    NotificationManager.error("Impossible de supprimer l'export");
                    this.setState({loading: false});
                })
        }
        else
            console.error("No User or API Instance");
    };

    render() {
        const { item } = this.props;
        const { name, frequency } = item;
        const { showForm } = this.state;

        return <div className="ty-block relative">
            <h4 className="ty-subtitle bold">
                { name }
            </h4>
            
            <i 
                className={`absolute top-10 right-20 icon icon-chevron-${showForm ? 'up' : 'down'} f-30 bold blue-hover pointer`} 
                onClick={this.toggleForm}
            >
            </i>
            
            <div>
                {
                    frequency ?
                        `Tous les ${frequency} jour${frequency > 1 ? 's' : ''}`
                        :
                        "Tous les derniers jour du mois"
                }    
            </div> 

            {
                showForm && <ExportFormRecurrent 
                    editMode 
                    data={item} 
                    onSubmit={this.postUpdate}
                    onCancel={this.toggleForm}
                    onRemove={this.removeExport}
                />
            }
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Operations/Export/RecItem.js